import { useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import { Input } from 'components/ideal-core-ui'
import s from './AddChecklistModal.scss'

const AddChecklistModal = ({
  toggleAddChecklistModal,
  isAddChecklistModalVisible,
  createChecklist,
  editedChecklist,
  updateChecklist,
  updateItem,
  editedItem
}) => {
  const [title, setTitle] = useState(
    editedChecklist ? editedChecklist.title : editedItem ? editedItem.item.name : ''
  )

  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={isAddChecklistModalVisible}
        toggle={toggleAddChecklistModal}
        size="md"
      >
        <ModalHeader toggle={toggleAddChecklistModal} className={s.modalHeader}>
          {editedChecklist ? 'Edit Checklist' : editedItem ? 'Edit Item' : 'Add Checklist'}
        </ModalHeader>
        <ModalBody>
          <Input
            type="text"
            onChangeCb={() => setTitle(event.target.value)}
            text={title}
            placeholder={editedItem ? 'Item Title' : 'Checklist Title'}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleAddChecklistModal}>
            Cancel
          </Button>
          <Button
            className={s.saveBtn}
            onClick={() => {
              if (editedChecklist) {
                updateChecklist(title, editedChecklist.id)
              } else if (editedItem) {
                updateItem(title, editedItem.item.id, editedItem.checklistId)
              } else {
                createChecklist(title)
              }
              toggleAddChecklistModal()
            }}
            disabled={title === ''}
          >
            Save
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default AddChecklistModal
